import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationItem } from '../../../layout/admin/navigation/navigation';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { PortalStorageService, RefreshService, DeviceService } from '@app/core/services';
import { AppConfig } from '@app/app-config';
import { environment } from '@environments/environment';
import { UrlTrackerService } from '@app/core/services/urlTracker.service';
import { DashboardDataStoreService } from '@app/pages/dashboard/dashboard-data-store.service';
import { LoggerService } from '@app/core/services/logger.service';
import { Constants } from '@app/core/config';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
    @Input() type: string;

    public navigation: any;
    breadcrumbList: Array<any> = [];
    public navigationList: Array<any> = [];
    public routerLinkUrls: string[] = ['/schedule/sched-utility'];
    // @Output() refreshClicked = new EventEmitter();
    public hideNav: boolean;
    public refreshTime: string;
    public prevUrl = '';
    private addPrevUrl = false;
    private forsite: string;

    constructor(
        private route: Router,
        public nav: NavigationItem,
        private titleService: Title,
        private storageService: PortalStorageService,
        private refreshService: RefreshService,
        public deviceService: DeviceService,
        private urlTracker: UrlTrackerService,
        private dataStore: DashboardDataStoreService,
        private customLogger: LoggerService,
    ) {
        this.navigation = this.nav.get();
        this.type = 'theme2';
        this.setBreadcrumb();
        this.routerLinkUrls = [`${this.storageService.getInitialUrl()}`];
        this.hideNav = JSON.parse(this.storageService.getNav());
        if (this.hideNav !== undefined && this.hideNav !== null) {
            this.hideNav = AppConfig.config.collapseNav;
        }
        this.addPrevUrl = false;

        if (environment.production) {
            if (environment.env == Constants.TEST) {
                this.forsite = '| Test';
            } else {
                this.forsite = '';
            }
        } else {
            this.forsite = '| Dev';
        }
    }

    ngOnInit(): void {
        const routerUrl = this.route.url;
        if (routerUrl && typeof routerUrl === 'string') {
            this.filterNavigation(routerUrl);
        }

        // Set Product Count
        this.refreshService.refreshTime.subscribe((msg: any) => {
            this.refreshTime = msg;
        });

        this.refreshService.pageTitle.subscribe((msg: any) => {
            this.setPageTitle(msg);
        });
    }

    setBreadcrumb(): void {
        let routerUrl: string;
        this.route.events.subscribe((router: any) => {
            routerUrl = router.urlAfterRedirects;
            if (routerUrl && typeof routerUrl === 'string') {
                this.breadcrumbList.length = 0;
                const activeLink = router.url;
                this.filterNavigation(activeLink);
            }
        });
    }

    filterNavigation(activeLink: string): void {
        let result = [];
        let title = 'Welcome';
        this.prevUrl = this.urlTracker.getPreviousUrl();
        // console.log(this.dataStore);
        // TODO: test edge cases
        if (
            this.prevUrl &&
            !this.urlTracker.menuItemClicked &&
            this.urlTracker.urlHistory.length > 0 &&
            this.urlTracker.urlHistory[this.urlTracker.urlHistory.length - 1] !== this.route.url
        ) {
            this.addPrevUrl = true;
        } else {
            this.addPrevUrl = false;
        }

        // if (this.prevUrl) {
        //     activeLink = this.prevUrl + activeLink;
        // }
        this.navigation.forEach((a) => {
            if (a.type === 'item' && 'url' in a && a.url === activeLink) {
                result = [
                    {
                        url: 'url' in a ? a.url : false,
                        title: a.title,
                        breadcrumbs: 'breadcrumbs' in a ? a.breadcrumbs : true,
                        type: a.type,
                        refreshLink: a.refreshLink,
                    },
                ];
                title = a.title;
            } else {
                if (a.type === 'group' && 'children' in a) {
                    a.children.forEach((b) => {
                        let splitUrl = '';
                        const bUrlWithId = b.url.includes('/:');
                        if (bUrlWithId) {
                            const bUrl = b.url.split('/:').map((item) => item.trim());
                            splitUrl = bUrl != null ? bUrl[0] : '';
                        }
                        if (b.type === 'item' && 'url' in b && b.url === activeLink) {
                            result = [
                                {
                                    url: 'url' in b ? b.url : false,
                                    title: b.title,
                                    breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                    type: b.type,
                                    refreshLink: b.refreshLink,
                                },
                            ];
                            title = b.title;
                        } else if (
                            //Edge case scenario for any detail page with /:id and with back navigation
                            b.type === 'item' &&
                            'url' in b &&
                            bUrlWithId &&
                            activeLink.includes(splitUrl)
                        ) {
                            result = [
                                {
                                    url: this.prevUrl,
                                    title: b.title,
                                    breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                    type: b.type,
                                    refreshLink: b.refreshLink,
                                },
                                {
                                    url: 'url' in b ? activeLink : false,
                                    title: b.title,
                                    breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                    type: b.type,
                                    refreshLink: b.refreshLink,
                                },
                            ];
                            title = b.title;
                        } else {
                            if (b.type === 'collapse' && 'children' in b) {
                                b.children.forEach((c) => {
                                    if (c.type === 'item' && 'url' in c && c.url === activeLink) {
                                        result = [
                                            {
                                                url: 'url' in b ? b.url : false,
                                                title: b.title,
                                                breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                                type: b.type,
                                                refreshLink: b.refreshLink,
                                            },
                                            {
                                                url: 'url' in c ? c.url : false,
                                                title: c.title,
                                                breadcrumbs: 'breadcrumbs' in c ? c.breadcrumbs : true,
                                                type: c.type,
                                                refreshLink: c.refreshLink,
                                            },
                                        ];

                                        /* result = this.addPrevUrl
                                            ? [
                                                  {
                                                      url: this.prevUrl,
                                                      title: 'Schedule Utility',
                                                      breadcrumbs: true,
                                                      type: 'item',
                                                      refreshLink: false,
                                                  },
                                                  {
                                                      url: 'url' in b ? b.url : false,
                                                      title: b.title,
                                                      breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                                      type: b.type,
                                                      refreshLink: b.refreshLink,
                                                  },
                                                  {
                                                      url: 'url' in c ? c.url : false,
                                                      title: c.title,
                                                      breadcrumbs: 'breadcrumbs' in c ? c.breadcrumbs : true,
                                                      type: c.type,
                                                      refreshLink: c.refreshLink,
                                                  },
                                              ]
                                            : [
                                                  {
                                                      url: 'url' in b ? b.url : false,
                                                      title: b.title,
                                                      breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                                      type: b.type,
                                                      refreshLink: b.refreshLink,
                                                  },
                                                  {
                                                      url: 'url' in c ? c.url : false,
                                                      title: c.title,
                                                      breadcrumbs: 'breadcrumbs' in c ? c.breadcrumbs : true,
                                                      type: c.type,
                                                      refreshLink: c.refreshLink,
                                                  },
                                              ]; */
                                        title = c.title;
                                    } else {
                                        if (c.type === 'collapse' && 'children' in c) {
                                            c.children.forEach((d) => {
                                                if (d.type === 'item' && 'url' in d && d.url === activeLink) {
                                                    result = [
                                                        {
                                                            url: 'url' in b ? b.url : false,
                                                            title: b.title,
                                                            breadcrumbs: 'breadcrumbs' in b ? b.breadcrumbs : true,
                                                            type: b.type,
                                                            refreshLink: b.refreshLink,
                                                        },
                                                        {
                                                            url: 'url' in c ? c.url : false,
                                                            title: c.title,
                                                            breadcrumbs: 'breadcrumbs' in c ? c.breadcrumbs : true,
                                                            type: c.type,
                                                            refreshLink: c.refreshLink,
                                                        },
                                                        {
                                                            url: 'url' in d ? d.url : false,
                                                            title: d.title,
                                                            breadcrumbs: 'breadcrumbs' in c ? d.breadcrumbs : true,
                                                            type: d.type,
                                                            refreshLink: d.refreshLink,
                                                        },
                                                    ];
                                                    title = d.title;
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            }
        });
        this.navigationList = result;
        this.setPageTitle(title);
    }

    onRefreshClick(): void {
        // this.refreshClicked.emit();
        this.refreshService.emitEvent();
    }

    async redirectToPreviousLocation(): Promise<void> {
        const storedNavList = this.navigationList.map((x) => x);
        if (this.urlTracker.urlHistory.length > 0) {
            this.dataStore.comingBack = true;
            const storedPrevUrl = this.urlTracker.urlHistory.pop();
            try {
                const didNavigate = await this.urlTracker.router.navigateByUrl(storedPrevUrl);
                // handles edge case: pressing back on unsaved changes
                if (!didNavigate) {
                    this.navigationList = storedNavList;
                    this.addPrevUrl = true;
                    this.urlTracker.urlHistory.push(storedPrevUrl);
                    this.dataStore.comingBack = false;
                }
            } catch (e) {
                this.customLogger.error(e);
            }
        }
    }

    setPageTitle(pageTitle: string): void {
        this.titleService.setTitle(`${pageTitle} ${this.forsite}`);
    }
}
